import type { UnleashClient } from 'unleash-proxy-client'

import { websiteBuilderCapabilityActive } from '@/features/hestia/queries/useBrandCapabilities'

/**
 * Resolves the shared Variant B gate for navigation, routes, and commands.
 * @param featureFlags Feature flags for the current session.
 * @param capabilityActive Brand capability state, defaulting to the reactive nav state.
 */
export function isWebsiteVariantBAvailable(
  featureFlags: UnleashClient,
  capabilityActive = websiteBuilderCapabilityActive.value
): boolean {
  return (
    featureFlags.isEnabled('hermes.websiteVariantBRoutes') && capabilityActive
  )
}
